<template>
  <div class="main">
    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        type="file"
        multiple
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=",.jpg,.jpeg,.png"
      />

      <label for="fileInput" class="file-label">
        <div v-if="isDragging" :style="isDragging && 'border-color: green;'">
          Release to drop files here.
        </div>
        <div v-else class="text-center">
          <span> Drop files here or <u>click here</u> to upload. </span>
          <div class="text-center">File(JPG/JPEG/PNG)</div>
        </div>
      </label>
      <div class="preview-container mt-4" v-if="files.length">
        <div v-for="file in files" :key="file.name" class="preview-card">
          <div class="preview-body">
            <img class="preview-img" :src="generateURL(file)" />
            <div class="file-details">
              <p>
                <span class="elips">{{ getFileName(file).name }}</span
                >{{ getFileName(file).type }}
              </p>
              <p>
                {{ bytesToSize(file.size).size + bytesToSize(file.size).sizeUnit }}
              </p>
            </div>

            <!-- <p>
             <span class="file-name"> </span>{{ getFileName(file).type }} - 
              {{ Math.round(file.size / 1000) + "kb" }}
            </p> -->
          </div>
          <div>
            <button
              class="ml-2 cross-icon"
              type="button"
              
              @click="remove(files.indexOf(file))"
              title="Remove file"
            >
            &times;

            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: "files",
    event: "input",
  },
  props: ["files"],
  data() {
    return {
      isDragging: false,
      uploadedFiles: this.files,
    };
  },
  methods: {
    onChange() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.file.files);
      const fileExist = self.uploadedFiles.some(r =>
        incomingFiles.some(file => file.name === r.name && file.size === r.size)
      );
      let len = self.uploadedFiles.length + incomingFiles.length;
      if (fileExist) {
      } else if (len > 50) {
        this.$toasted.error("You cannot Upload more than 50 files");
      } else {
        self.uploadedFiles.push(...incomingFiles);
      }
      this.$emit("input", self.uploadedFiles);
    },

    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.uploadedFiles.splice(i, 1);
      this.$emit("input", this.uploadedFiles);
    },
    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    getFileName(file) {
      let newFile = file.name.split(".");
      return {
        name: newFile.slice(0, newFile.length - 1).join(""),
        type: newFile[newFile.length - 1],
      };
    },
  },
  watch: {
    files(v) {
      if (!v || !v.length) {
        this.uploadedFiles = [];
      }
    },
  },
};
</script>
